"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextProvider = void 0;
const React = __importStar(require("react"));
const Contexts = __importStar(require("../contexts"));
class ContextProvider extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activatedQuantitySelectors: props.activatedQuantitySelectors,
            conversionParametersMap: createConversionParametersMap(props.productProperties),
            fieldGroup: props.fieldGroup,
            filterPrettyPrint: props.filterPrettyPrint,
            getAmountFormat: props.getAmountFormat,
            layoutRendererExtraProps: props.layoutRendererExtraProps,
            onQuantityChange: props.onQuantityChange,
            valueSources: props.valueSources,
            groupFilter: new Set(props.groupFilter),
            showGroups: props.showGroups,
            translatePropertyValue: props.translatePropertyValue,
            fieldNameMap: props.fieldNameMap
        };
    }
    static getDerivedStateFromProps(nextProps, _prevState) {
        return {
            activatedQuantitySelectors: nextProps.activatedQuantitySelectors,
            conversionParametersMap: createConversionParametersMap(nextProps.productProperties),
            fieldGroup: nextProps.fieldGroup,
            filterPrettyPrint: nextProps.filterPrettyPrint,
            getAmountFormat: nextProps.getAmountFormat,
            layoutRendererExtraProps: nextProps.layoutRendererExtraProps,
            onQuantityChange: nextProps.onQuantityChange,
            valueSources: nextProps.valueSources,
            groupFilter: new Set(nextProps.groupFilter),
            showGroups: nextProps.showGroups,
            translatePropertyValue: nextProps.translatePropertyValue,
            fieldNameMap: nextProps.fieldNameMap
        };
    }
    render() {
        return (React.createElement(Contexts.propertiesSelectorContext.Provider, { value: this.state }, React.Children.only(this.props.children)));
    }
}
exports.ContextProvider = ContextProvider;
function createConversionParametersMap(productProperties) {
    const map = productProperties.reduce((soFar, property) => {
        soFar[property.name] = property.conversionParameters;
        return soFar;
    }, {});
    return map;
}
//# sourceMappingURL=context-provider.js.map